export default {
  props: {
    dark: {
      type: Boolean,
      default: true
    },
    light: {
      type: Boolean,
      default: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/vuetify/selects/mixins/themeable.js